export default "__VITE_ASSET__By6Y21QM__"